export default __webpack_public_path__ + "using-shake-for-customer-support.jpg";